module.exports = __webpack_public_path__ + "static/img/22.c5d8a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/22.jpg
// module id = oM2P
// module chunks = 1